import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId, useCallback } from 'react';
import { ExclamationCircleIcon } from '@iris/react-icons/ExclamationCircleIcon';
import { InlineMessage } from '../../InlineMessage/InlineMessage.esm.js';
import { useSliderA11y } from '../context/SliderA11yProvider.esm.js';
import { RangeInput } from './RangeInput.esm.js';
import { rangeInputStyles } from './RangeInputs.styles.esm.js';
import { cn } from '../../../utils/cn.esm.js';

const RangeSliderInputs = forwardRef((props, ref) => {
    const { min, max, lower, upper, disabled, inverse, error, errorMessage, helperText, helperTextMessage, onLowerChange, onUpperChange, onLowerBlur, onUpperBlur, separatorAriaLabel, minLabel, maxLabel, minInputClassName, maxInputClassName, } = props;
    const { setRangeLowerInputRef, setRangeUpperInputRef } = useSliderA11y();
    const { wrapper, row, sep, helper: helperTextClasses, error: errorClasses, inlineMessage: inlineMessageClasses, } = rangeInputStyles({ error, inverse, disabled });
    const helperTextId = `range-slider-helper-text-${useId()}`;
    const errorTextId = `range-slider-error-text-${useId()}`;
    const commonInputProps = {
        disabled,
        min,
        max,
        error,
        inverse,
        helperText,
        helperTextMessage,
        idHelperText: helperTextId,
        idErrorText: errorTextId,
        errorMessage,
    };
    const inputs = [
        {
            key: "min",
            label: minLabel,
            value: lower,
            onChange: onLowerChange,
            onBlur: onLowerBlur,
            className: minInputClassName,
        },
        {
            key: "max",
            label: maxLabel,
            value: upper,
            onChange: onUpperChange,
            onBlur: onUpperBlur,
            className: maxInputClassName,
        },
    ];
    const setLowerRef = useCallback((node) => setRangeLowerInputRef(node), [setRangeLowerInputRef]);
    const setUpperRef = useCallback((node) => setRangeUpperInputRef(node), [setRangeUpperInputRef]);
    return (jsxs("div", { ref: ref, className: wrapper(), children: [jsxs("div", { className: row(), children: [inputs.map(({ key, label, value, onChange, onBlur, className }) => (jsx(RangeInput, Object.assign({ label: label, value: value, onChange: onChange, onBlur: onBlur, className: className, ref: key === "min" ? setLowerRef : setUpperRef }, commonInputProps), key))), jsx("span", { className: sep(), "aria-hidden": "true", children: "\u2013" }), jsx("span", { className: "iris:sr-only", children: separatorAriaLabel })] }), helperText && (jsx("span", { id: helperTextId, className: helperTextClasses(), children: helperTextMessage })), error && errorMessage && (jsx(InlineMessage, { id: errorTextId, disabled: disabled, icon: jsx(ExclamationCircleIcon, {}), iconClass: cn(errorClasses(), "iris:self-start"), label: errorMessage, labelClass: errorClasses(), className: inlineMessageClasses() }))] }));
});
RangeSliderInputs.displayName = "RangeSliderInput";

export { RangeSliderInputs };
